import { z } from 'zod';
import { createValidator } from '../core/validators';

// Base request schema with all common fields
export const requestSchema = z.object({
  id: z.string(),
  title: z.string(),
  description: z.string(),
  userId: z.string(),
  voteCount: z.number().min(0).default(0),
  commentCount: z.number().min(0).default(0),
  createdAt: z.string(),
  updatedAt: z.string().optional(),
  userEmail: z.string().email().optional(),
  userDisplayName: z.string().nullish(), // Allow null, undefined, or string
  userHasVoted: z.boolean().optional().default(false)
});

// Create request input schema (for new requests)
export const createRequestSchema = z.object({
  title: z.string().min(1, 'Title is required').max(100, 'Title must be less than 100 characters'),
  description: z.string().min(1, 'Description is required').max(2000, 'Description must be less than 2000 characters')
});

// User request schema (for my-requests endpoint)
export const userRequestSchema = requestSchema.extend({
  userEmail: z.string().email(),
  userDisplayName: z.string().nullish() // Allow null, undefined, or string
});

// Supported request schema (for liked requests)
export const supportedRequestSchema = requestSchema.extend({
  userEmail: z.string().email().optional(),
  userDisplayName: z.string().nullish(), // Allow null, undefined, or string
  userHasVoted: z.boolean().default(true)
});

// Create named validators
export const validateRequest = createValidator(requestSchema, 'Request');
export const validateCreateRequest = createValidator(createRequestSchema, 'CreateRequest');
export const validateUserRequest = createValidator(userRequestSchema, 'UserRequest');
export const validateSupportedRequest = createValidator(supportedRequestSchema, 'SupportedRequest');